var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6471 14.587C12.0376 14.1965 12.0376 13.5633 11.6471 13.1728L6.41421 7.93988L11.6471 2.70699C12.0376 2.31647 12.0376 1.6833 11.6471 1.29278C11.2566 0.902252 10.6234 0.902252 10.2329 1.29278L4.29289 7.23278C3.90237 7.6233 3.90237 8.25647 4.29289 8.64699L10.2329 14.587C10.6234 14.9775 11.2566 14.9775 11.6471 14.587Z",
    fill: "#234596"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS42NDcxIDE0LjU4N0MxMi4wMzc2IDE0LjE5NjUgMTIuMDM3NiAxMy41NjMzIDExLjY0NzEgMTMuMTcyOEw2LjQxNDIxIDcuOTM5ODhMMTEuNjQ3MSAyLjcwNjk5QzEyLjAzNzYgMi4zMTY0NyAxMi4wMzc2IDEuNjgzMyAxMS42NDcxIDEuMjkyNzhDMTEuMjU2NiAwLjkwMjI1MiAxMC42MjM0IDAuOTAyMjUyIDEwLjIzMjkgMS4yOTI3OEw0LjI5Mjg5IDcuMjMyNzhDMy45MDIzNyA3LjYyMzMgMy45MDIzNyA4LjI1NjQ3IDQuMjkyODkgOC42NDY5OUwxMC4yMzI5IDE0LjU4N0MxMC42MjM0IDE0Ljk3NzUgMTEuMjU2NiAxNC45Nzc1IDExLjY0NzEgMTQuNTg3WiIgZmlsbD0iIzIzNDU5NiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };